import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import { convertMsToSeconds as X } from "../util/date-utils.js";
import { logger as E, Guid as P, EventTypes as m } from "../../shared-lib/index.js";
var Kt = /*#__PURE__*/function () {
  function Kt(s, t, i, e) {
    _classCallCheck(this, Kt);
    this.j = s, this.Cs = t, this.h = i, this.Sl = e, this.j = s, this.Cs = t, this.h = i, this.jl = 1e3, (null == e || isNaN(e)) && (e = 1800), e < this.jl / 1e3 && (E.info("Specified session timeout of " + e + "s is too small, using the minimum session timeout of " + this.jl / 1e3 + "s instead."), e = this.jl / 1e3), this.Sl = e;
  }
  _createClass(Kt, [{
    key: "xl",
    value: function xl(s, t) {
      return new ue(this.Cs.getUserId(), m.Dl, s, t.eu, {
        d: X(s - t.Gl)
      });
    }
  }, {
    key: "bt",
    value: function bt() {
      var t = this.j.tu(s.iu.Nl);
      return null == t ? null : t.eu;
    }
  }, {
    key: "zl",
    value: function zl() {
      var t = new Date().valueOf(),
        i = this.h.Rl();
      if (null == i) return !1;
      var e = this.j.lt(s.ct.Hl),
        n = null == e || t - e > 1e3 * i;
      return n && this.j.ft(s.ct.Hl, t), n;
    }
  }, {
    key: "Wl",
    value: function Wl(s, t) {
      return null == t || null == t.kl || !(s - t.Gl < this.jl) && t.kl < s;
    }
  }, {
    key: "qo",
    value: function qo() {
      var t = new Date().valueOf(),
        i = t + 1e3 * this.Sl,
        e = this.j.tu(s.iu.Nl);
      if (this.Wl(t, e)) {
        var n = "Generating session start event with time " + t;
        if (null != e) {
          var _s = e.ql;
          _s - e.Gl < this.jl && (_s = e.Gl + this.jl), this.j.yl(this.xl(_s, e)), n += " (old session ended " + _s + ")";
        }
        n += ". Will expire " + i.valueOf(), E.info(n);
        var o = new _t(P.oe(), i);
        this.j.yl(new ue(this.Cs.getUserId(), m.Al, t, o.eu)), this.j.uu(s.iu.Nl, o);
        return null == this.j.lt(s.ct.Hl) && this.j.ft(s.ct.Hl, t), o.eu;
      }
      if (null != e) return e.ql = t, e.kl = i, this.j.uu(s.iu.Nl, e), e.eu;
    }
  }, {
    key: "Bl",
    value: function Bl() {
      var t = this.j.tu(s.iu.Nl);
      null != t && (this.j.Fl(s.iu.Nl), this.j.yl(this.xl(new Date().valueOf(), t)));
    }
  }]);
  return Kt;
}();
export { Kt as default };